var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex ma-10 justify-center"},[_c('v-progress-circular',_vm._g(_vm._b({attrs:{"indeterminate":"","color":"grey"}},'v-progress-circular',_vm.$attrs,false),_vm.$attrs))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }